export const SMALL = 768
export const MEDIUM = 992
export const LARGE = 1200

export const minWidth = size => `(min-width: ${size}px)`
export const maxWidth = size => `(max-width: ${size}px)`



// WEBPACK FOOTER //
// ./src/screens/App/shared/utils/media-query.js